module.exports = __webpack_public_path__ + "img/required.df27a956.svg";